import { useContext, useMemo } from "react";
import { useAuth0 } from "@stadium/services/auth0";

import { FeatureFlagProvider } from "@stadium/services/launch-darkly";
import { CurrentUserContext } from "@contexts/current-user-provider";

import { LAUNCH_DARKYLY_CLIENT_ID } from "@constants/env-variables";

const LaunchDarklyWrapper = ({ children }) => {
  const { user, isLoading, isAuthenticated } = useAuth0();
  const { currentUserData, ldData } = useContext(CurrentUserContext);
  const { firstName, lastName, email } = currentUserData;
  const name = `${firstName} ${lastName}`;
  const { userKey: key, secureModeHash: hash } = ldData;

  const isReadyForInit = !isLoading && (isAuthenticated ? !!email : true);

  const configurations = useMemo(
    () => ({
      user: { key, name, email },
      options: { hash },
    }),
    [key, name, email, hash]
  );

  return (
    <FeatureFlagProvider
      user={user}
      isReadyForInit={isReadyForInit}
      clientSideID={LAUNCH_DARKYLY_CLIENT_ID}
      configurations={configurations}
    >
      {children}
    </FeatureFlagProvider>
  );
};

export default LaunchDarklyWrapper;
